<template>
  <v-list-item>
    <v-row dense>
      <v-col cols="12" sm="2">
        <span>
        {{ saldo.saldo }} {{ compraProduto.unidadeMedida.descricao }}
      </span>
        <span class="caption">
        <px-entrega-produto-saldo-situacao :situacao="saldo.situacaoEntrega"/>
      </span>
        <span v-if="saldo.observacaoInterna">
          <px-show-large-text :large-text="saldo.observacaoInterna"/>
      </span>
      </v-col>
      <v-col cols="12" sm="2">
        {{ saldo.dataPrevisaoFaturamento | date }}
        <div class="caption">
          Previsão de faturamento
        </div>
      </v-col>
      <v-col cols="12" sm="2" v-if="controlaFaturamento && isFaturadoOuEntregue">
        <template v-if="saldo.dataFaturamento">
          {{ saldo.dataFaturamento | date }}
          <div class="caption">
            Data de faturamento
          </div>
        </template>
      </v-col>
      <v-col cols="12" sm="2">
        {{ saldo.dataPrevisaoEntrega | date }}
        <div class="caption">
          Previsão de entrega
        </div>
      </v-col>
      <v-col cols="12" sm="2">
        <template v-if="saldo.dataEntrega && isEntregue">
          {{ saldo.dataEntrega | date }}
          <div class="caption">
            Data de entrega
          </div>
        </template>
      </v-col>
    </v-row>
    <v-list-item-action v-if="isPendente && controlaFaturamento">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon
                 :disabled="loadingOperation"
                 v-on="on"
                 @click="onClickFaturar">
            <v-icon>
              mdi-file-check-outline
            </v-icon>
          </v-btn>
        </template>
        <span>Marcar como faturado</span>
      </v-tooltip>
    </v-list-item-action>
    <v-list-item-action v-if="isPendente || isFaturado">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon
                 :disabled="loadingOperation"
                 v-on="on"
                 @click="onClickEntregar">
            <v-icon>
              mdi-check
            </v-icon>
          </v-btn>
        </template>
        <span>Marcar como entregue</span>
      </v-tooltip>
    </v-list-item-action>
    <v-list-item-action v-if="isEntregue">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon
                 v-on="on"
                 :disabled="loadingOperation"
                 @click="onClickRevert">
            <v-icon>
              mdi-arrow-u-left-top
            </v-icon>
          </v-btn>
        </template>
        <span>{{ rollbackDescription }}</span>
      </v-tooltip>

    </v-list-item-action>
    <px-gestao-entrega-produtos-compras-item-menu :saldo="saldo"
                                                  @change="emitChange"/>
  </v-list-item>
</template>

<script>
import { SituacaoGestaoEntregaProdutoSaldo } from 'px-business-components';
import GestaoEntregaProdutosComprasItemMenu
  from '@/modules/gestao-entregas/GestaoEntregaProdutosComprasItemMenu.vue';
import GestaoEntregaService from '@/modules/gestao-entregas/gestao-entrega-service';

export default {
  props: {
    compraProduto: Object,
    controlaFaturamento: {
      type: Boolean,
      default: false,
    },
    saldo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingOperation: false,
    };
  },
  computed: {
    isEntregue() {
      return this.saldo.situacaoEntrega === SituacaoGestaoEntregaProdutoSaldo.keys.ENTREGUE.key;
    },
    isCancelado() {
      return this.saldo.situacaoEntrega === SituacaoGestaoEntregaProdutoSaldo.keys.CANCELADO.key;
    },
    isPendente() {
      return this.saldo.situacaoEntrega === SituacaoGestaoEntregaProdutoSaldo.keys.PENDENTE.key;
    },
    isFaturado() {
      return this.saldo.situacaoEntrega === SituacaoGestaoEntregaProdutoSaldo.keys.FATURADO.key;
    },
    isFaturadoOuEntregue() {
      return this.isFaturado || this.isEntregue;
    },
    rollbackDescription() {
      if (this.isEntregue) {
        return 'Voltar para pendente';
      }
      return '';
    },
  },
  methods: {
    emitChange(data) {
      this.$emit('change', data);
    },
    updateSaldo(payload) {
      this.loadingOperation = true;
      GestaoEntregaService.updateSaldoEntrega(this.saldo.id, payload)
        .then(({ data }) => {
          this.emitChange(data);
        }).finally(() => {
          this.loadingOperation = false;
        });
    },
    onClickFaturar() {
      if (this.isEntregue || this.isCancelado) {
        return;
      }
      const payload = {
        id: this.saldo.id,
        dataFaturamento: new Date(),
        situacaoEntrega: SituacaoGestaoEntregaProdutoSaldo.keys.FATURADO.key,
      };

      this.updateSaldo(payload);
    },
    onClickEntregar() {
      if (this.isEntregue || this.isCancelado) {
        return;
      }
      const payload = {
        id: this.saldo.id,
        dataEntrega: new Date(),
        situacaoEntrega: SituacaoGestaoEntregaProdutoSaldo.keys.ENTREGUE.key,
      };
      this.updateSaldo(payload);
    },
    onClickRevert() {
      if (this.isPendente || this.isFaturado || this.isCancelado) {
        return;
      }
      const payload = {
        id: this.saldo.id,
        situacaoEntrega: SituacaoGestaoEntregaProdutoSaldo.keys.PENDENTE.key,
        dataEntrega: null,
      };
      this.updateSaldo(payload);
    },
  },
  components: {
    pxGestaoEntregaProdutosComprasItemMenu: GestaoEntregaProdutosComprasItemMenu,
  },
};
</script>
